// utils/productHref.ts

import { slugify } from "./slug";

type ProductLike = {
  id: string | number;
  translation?: { title?: string };
  title?: string; // fallback se alcune API usano "title" al posto di translation.title
};

export function productHref(p: ProductLike) {
  if (!p) return "#";

  const title =
    p?.translation?.title ||
    p?.title ||
    "";

  return `/product/${p.id}/${slugify(title)}`;
}
